/* Evashu Content Experience v10 — progressive enhancement only. */
(function(){
  function onReady(fn){
    if(document.readyState==='loading'){
      document.addEventListener('DOMContentLoaded',function(){setTimeout(fn,0)},{once:true});
    }else{setTimeout(fn,0);}
  }

  function setupActiveToc(root){
    var prose=root.querySelector('.evc__prose');
    if(!prose) return;
    var headings=Array.prototype.slice.call(prose.querySelectorAll('h2[id],h3[id]'));
    if(!headings.length) return;
    var links=Array.prototype.slice.call(root.querySelectorAll('[data-evc-toc-target] a[href^="#"]'));
    if(!links.length) return;

    function setActive(id){
      links.forEach(function(link){
        var active=link.getAttribute('href')==='#'+id;
        link.classList.toggle('is-active',active);
        if(active) link.setAttribute('aria-current','location');
        else link.removeAttribute('aria-current');
      });
    }

    if('IntersectionObserver' in window){
      var visible={};
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting) visible[entry.target.id]=entry.boundingClientRect.top;
          else delete visible[entry.target.id];
        });
        var ids=Object.keys(visible);
        if(ids.length){
          ids.sort(function(a,b){return Math.abs(visible[a])-Math.abs(visible[b]);});
          setActive(ids[0]);
        }
      },{rootMargin:'-18% 0px -68% 0px',threshold:[0,1]});
      headings.forEach(function(h){observer.observe(h);});
    }

    links.forEach(function(link){
      link.addEventListener('click',function(){
        var id=(link.getAttribute('href')||'').slice(1);
        if(id) setActive(id);
      });
    });
  }

  function setupProgress(root){
    if(document.querySelector('.evc__reading-progress')) return;
    var bar=document.createElement('div');
    bar.className='evc__reading-progress';
    bar.setAttribute('aria-hidden','true');
    var fill=document.createElement('i');
    bar.appendChild(fill);
    document.body.appendChild(bar);

    var scheduled=false;
    function update(){
      scheduled=false;
      var rect=root.getBoundingClientRect();
      var pageY=window.scrollY||window.pageYOffset||0;
      var start=rect.top+pageY;
      var height=Math.max(root.offsetHeight-window.innerHeight,1);
      var progress=Math.max(0,Math.min(1,(pageY-start)/height));
      fill.style.width=(progress*100).toFixed(2)+'%';
    }
    function schedule(){
      if(!scheduled){scheduled=true;window.requestAnimationFrame(update);}
    }
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    update();
  }

  function linkifyTrust(root){
    var panels=root.querySelectorAll('.evc__trust-panel--sources');
    panels.forEach(function(panel){
      var walker=document.createTreeWalker(panel,NodeFilter.SHOW_TEXT,null);
      var nodes=[];
      while(walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function(node){
        var text=node.nodeValue||'';
        var re=/https?:\/\/[^\s<]+/g;
        if(!re.test(text)) return;
        re.lastIndex=0;
        var frag=document.createDocumentFragment();
        var last=0,match;
        while((match=re.exec(text))){
          if(match.index>last) frag.appendChild(document.createTextNode(text.slice(last,match.index)));
          var raw=match[0];
          var trailing='';
          while(/[),.;]$/.test(raw)){trailing=raw.slice(-1)+trailing;raw=raw.slice(0,-1);}
          var a=document.createElement('a');
          a.href=raw;a.target='_blank';a.rel='noopener noreferrer';
          a.textContent=raw.replace(/^https?:\/\//,'').replace(/\/$/,'');
          frag.appendChild(a);
          if(trailing) frag.appendChild(document.createTextNode(trailing));
          last=match.index+match[0].length;
        }
        if(last<text.length) frag.appendChild(document.createTextNode(text.slice(last)));
        node.parentNode.replaceChild(frag,node);
      });
    });
  }

  function assetSibling(name){
    var scripts=document.querySelectorAll('script[src*="evashu-content-v10.js"]');
    var source=scripts.length?scripts[scripts.length-1].src:'';
    if(!source) return '';
    try{
      var url=new URL(source,window.location.href);
      url.pathname=url.pathname.replace(/evashu-content-v10\.js$/,'')+name;
      url.search='';
      url.hash='';
      return url.toString();
    }catch(e){return '';}
  }

  function loadUtilityExperience(){
    if(!document.querySelector('.evc')) return;
    var cssUrl=assetSibling('evashu-content-utility.css');
    var jsUrl=assetSibling('evashu-content-utility.js');
    if(cssUrl&&!document.querySelector('link[data-evc-utility-css]')){
      var link=document.createElement('link');
      link.rel='stylesheet';link.href=cssUrl;link.setAttribute('data-evc-utility-css','true');
      document.head.appendChild(link);
    }
    if(jsUrl&&!document.querySelector('script[data-evc-utility-js]')){
      var script=document.createElement('script');
      script.src=jsUrl;script.defer=true;script.setAttribute('data-evc-utility-js','true');
      document.head.appendChild(script);
    }
  }

  function init(){
    document.querySelectorAll('.evc').forEach(function(root){
      root.classList.add('evc--v10');
      setupActiveToc(root);
      setupProgress(root);
      linkifyTrust(root);
    });
    loadUtilityExperience();
  }
  onReady(init);
})();
